import { MenuItemProps, MenuItem as MuiMenuItem } from "@mui/material";
import { sxMenuItem } from "./sxProps";

const MenuItem: React.FC<MenuItemProps> = ({ onClick, children }) => {

  return (
    <MuiMenuItem sx={sxMenuItem} onClick={onClick}>
      {children}
    </MuiMenuItem>
  );
}

export default MenuItem;